import { Link, NavLink } from "react-router-dom";
import { Dashboardsvg, SidebarCatchRetirn, SidebarCompitition, SidebarMapParking, SidebarMember, SidebarReportIncedent, SidebarRiverLavel, SidebarRulesRegulations, SidebarVehicles } from "../../SvgFile/Index";
import { useEffect, useState } from "react";
import Logout from "../../Component/Pages/Auth/Logout";
import SideBarLink from "../SideBarLink";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [links, setlinks] = useState([]);


  const user = JSON.parse(localStorage.getItem("memberData"));

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let links = [
      {
        url: "/member/catch-return",
        roleName: "Submit Catch Return",
        icon: <SidebarCatchRetirn />,
      },
      {
        url: "/maps-parking-info",
        roleName: "Maps & Parking Info",
        icon: <SidebarMapParking />,
      },
      {
        url: "/report-an-incident",
        roleName: "Report an Incident",
        icon: <SidebarReportIncedent />,
      },
      {
        url: "/rules-regulations",
        roleName: "Rules & Regulations",
        icon: <SidebarRulesRegulations />,
      },
      {
        url: "/competitions-dinners",
        roleName: "Competitions & Dinners",
        icon: <SidebarCompitition />,
      },
      {
        url: "/river-levels-weather",
        roleName: "River Levels & Weather",
        icon: <SidebarRiverLavel />,
      },
      {
        url: "/vehicle-check",
        roleName: "Vehicle Check",
        icon: <SidebarVehicles />,
      },


    ];

    setlinks(links);

    // eslint-disable-next-line
  }, []);



  return (
    <div class="main_container">
      <div className="intersight_menu">
        <div className="top_menu">
          <div className="brand">
            <button
              className="border-0 w-100 d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-flex align-items-center justify-content-center">
                <img src="/image/fish.svg" alt="" srcSet="" className="img-fluid" />
              </span>
              <div className="brand_dashboard">
                <span>Glendale Grayling Club</span>
                <h6>Est. 1838</h6>
              </div>
            </button>
          </div>

          <div class="intersight_home">
            <div class="menu_div user_menu">
              <ul>
                <li>
                  <NavLink
                    to="/member/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>{" "}
                    Dashboard
                  </NavLink>
                </li>
                <li className="without_label">Workspace</li>


                {links?.map((item, i) => (
                  <SideBarLink
                    key={i}
                    href={item?.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
                <li className="without_label">Committee member</li>
                <li>
                  <NavLink
                    to="/check-member-info"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <SidebarMember />
                    </span>{" "}
                    Check Member Info
                  </NavLink>
                </li>

              </ul>
              <div class="bottom_menu">
                <div class="dropdown">
                  <button class="dropdown-toggle border-0 w-100 d-flex align-items-center" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="d-flex align-items-center justify-content-center person_icon">
                      <img src={user?.picture?.url} alt="" className="img-fluid" onError={(e) => {
                        e.target.src = "/image/person.svg";
                        e.target.onerror = null;
                      }} /></span>
                    <label class="person_name">
                      {user?.firstName} {user?.surname}
                      <span className="d-block">{user?.status
                        ? user.status
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())
                        : ""}&nbsp;</span>
                    </label>
                  </button>
                  <ul className="dropdown-menu w-100">

                    <li>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() => setOpen(true)}
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </div>
  );
}
